import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

const csrfTokenElement = document.querySelector('meta[name="csrf-token"]');

let csrfToken = csrfTokenElement?.getAttribute('content');

const link = new HttpLink({
  uri: '/graphql',
  fetch: async (uri, options: { headers?: Record<string, string> } = {}) => {
    if (options.headers == null) {
      options.headers = {};
    }

    if (csrfToken != null) {
      options.headers['X-CSRF-Token'] = csrfToken;
    }

    const response = await fetch(uri, options);

    // Reload to display the maintenance page if the response status is 503
    if (response.status === 503) {
      location.reload();

      throw new Error('Service unavailable');
    }

    const responseCsrfToken = response.headers.get('X-CSRF-Token');

    if (responseCsrfToken != null) {
      csrfToken = responseCsrfToken;
      // @rails/activestorage reads the CSRF token from the meta tag, so that
      // needs to be updated too
      csrfTokenElement?.setAttribute('content', csrfToken);
    }

    return response;
  },
});

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

export default client;
